import { useRef } from "react";

const DEFAULT_THROTTLE_TIME = 200;

type ThrottleFunc = (inQueue: boolean) => void;

export const useThrottleFunc = (time: number = DEFAULT_THROTTLE_TIME) => {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const queueRef = useRef<ThrottleFunc[]>([]);

    const throttle = (func: ThrottleFunc) => {
        if (timeoutRef.current) {
            queueRef.current.push(func);
        } else {
            func(false);

            timeoutRef.current = setTimeout(handleTimeout, time);
        }
    };

    const handleTimeout = () => {
        timeoutRef.current = null;
        queueRef.current[queueRef.current.length - 1] && queueRef.current[queueRef.current.length - 1](true);
        queueRef.current = [];
    };

    return throttle;
};
